const KeenSlider = window.KeenSlider

class ListCollectionCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()
    this.carousel = this.initialiseCarousel()
    this.updateCarousel()
  }

  setupListeners () {}

  reinitCarousel () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = this.initialiseCarousel()
    }

    super.reinitialise()
  }

  updateCarousel () {
    if (this.carousel) {
      setTimeout(() => {
        this.carousel.update()
      }, 0)
    }
  }

  initialiseCarousel () {
    if (
      !this.els?.slides?.exists ||
      !this.els?.slide?.exists ||
      this.dataset.enabledCarousel !== 'true' ||
      window.innerWidth > 767
    ) { return }
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      loop: false,
      mode: 'snap',
      disabled: false,
      slides: {
        perView: 2,
        spacing: 4,
      },
      breakpoints: {
        '(min-width: 768px)': {
          disabled: true,
        },
      },
    })
  }
}

if (!customElements.get('list-collection-carousel')) {
  customElements.define('list-collection-carousel', ListCollectionCarousel)
}
